import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    loadAdminUsers: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'admin-users/list',
                    method: 'GET',
                    types: [
                        types.LOAD_ADMIN_USERS_REQUEST,
                        types.LOAD_ADMIN_USERS_SUCCESS,
                        types.LOAD_ADMIN_USERS_FAILURE
                    ]
                }
            });
        }
    },
    getAdminProfile: (userId) => {
        return (dispatch) => {
            const body = {
                id: userId
            };
            
            return dispatch({
                [CALL_API]: {
                    endpoint: 'admin-users/search',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_ADMIN_REQUEST,
                        types.LOAD_ADMIN_SUCCESS,
                        types.LOAD_ADMIN_FAILURE
                    ]
                }
            });
        }
    },
    getAdminProfileFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'admin-users/filters',
                    method: 'GET',
                    types: [
                        types.LOAD_ADMIN_FILTERS_REQUEST,
                        types.LOAD_ADMIN_FILTERS_SUCCESS,
                        types.LOAD_ADMIN_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    saveAdminProfile: (admin) => {
        return (dispatch) => {
            if (admin.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'admin-users/create',
                        method: 'POST',
                        body: admin,
                        types: [
                            types.CREATE_ADMIN_REQUEST,
                            types.CREATE_ADMIN_SUCCESS,
                            types.CREATE_ADMIN_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'admin-users/update',
                        method: 'PUT',
                        body: admin,
                        types: [
                            types.UPDATE_ADMIN_REQUEST,
                            types.UPDATE_ADMIN_SUCCESS,
                            types.UPDATE_ADMIN_FAILURE
                        ]
                    }
                });
            }
        }
    }
}
